import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.module.scss';

export const Icons = (props) => {
  const { className, variant, onClick, testid, color } = props;

  const getIcons = () => {
    switch (variant) {
      case Icons.SETTINGS: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="10" cy="10" r="2.5" stroke="#262626" strokeWidth="2" />
            <path
              d="M3.1298 10.2598L3.96431 10.8108C4.07923 10.6368 4.13685 10.4311 4.12911 10.2227L3.1298 10.2598ZM3.1298 9.74018L4.12911 9.77731C4.13685 9.56888 4.07923 9.36324 3.96431 9.18919L3.1298 9.74018ZM1.91047 7.89343L2.74499 7.34244L2.74499 7.34244L1.91047 7.89343ZM1.87108 6.57969L2.73711 7.07969H2.73711L1.87108 6.57969ZM2.97354 4.67018L2.10751 4.17018L2.10751 4.17018L2.97354 4.67018ZM4.13097 4.04742L4.07105 5.04563H4.07105L4.13097 4.04742ZM6.33872 4.17994L6.2788 5.17814C6.48759 5.19067 6.69505 5.13742 6.872 5.02588L6.33872 4.17994ZM6.79097 3.91831L7.2584 4.80235C7.44281 4.70484 7.59211 4.55211 7.6854 4.36553L6.79097 3.91831ZM7.77964 1.94098L8.67407 2.3882V2.3882L7.77964 1.94098ZM12.2206 1.94098L13.115 1.49377V1.49377L12.2206 1.94098ZM13.2094 3.91853L12.315 4.36575C12.4082 4.5523 12.5575 4.70503 12.7419 4.80253L13.2094 3.91853ZM13.6615 4.18007L13.1281 5.02599C13.3051 5.13755 13.5126 5.19081 13.7214 5.17827L13.6615 4.18007ZM15.8691 4.04756L15.8092 3.04935L15.8691 4.04756ZM17.0266 4.67031L16.1605 5.17031V5.17031L17.0266 4.67031ZM18.129 6.57982L18.9951 6.07982L18.129 6.57982ZM18.0896 7.89356L18.9241 8.44455L18.9241 8.44455L18.0896 7.89356ZM16.8702 9.74052L16.0357 9.18953C15.9207 9.36357 15.8631 9.56919 15.8709 9.7776L16.8702 9.74052ZM16.8702 10.2595L15.8709 10.2224C15.8631 10.4308 15.9207 10.6364 16.0357 10.8105L16.8702 10.2595ZM18.0896 12.1064L18.9241 11.5555L18.9241 11.5554L18.0896 12.1064ZM18.129 13.4202L18.9951 13.9202L18.9951 13.9202L18.129 13.4202ZM17.0266 15.3297L16.1605 14.8297V14.8297L17.0266 15.3297ZM15.8691 15.9524L15.9291 14.9542H15.9291L15.8691 15.9524ZM13.6614 15.8199L13.7214 14.8217C13.5126 14.8092 13.3051 14.8625 13.1281 14.974L13.6614 15.8199ZM13.2094 16.0815L12.7419 15.1975C12.5575 15.295 12.4082 15.4477 12.315 15.6343L13.2094 16.0815ZM12.2206 18.059L13.115 18.5062L13.115 18.5062L12.2206 18.059ZM7.77964 18.059L8.67407 17.6118L8.67407 17.6118L7.77964 18.059ZM6.79097 16.0817L7.6854 15.6345C7.59211 15.4479 7.44281 15.2952 7.2584 15.1977L6.79097 16.0817ZM6.33871 15.8201L6.87199 14.9741C6.69505 14.8626 6.48759 14.8093 6.2788 14.8219L6.33871 15.8201ZM4.13097 15.9526L4.07105 14.9544H4.07105L4.13097 15.9526ZM2.97354 15.3298L2.10751 15.8298H2.10751L2.97354 15.3298ZM1.87108 13.4203L1.00506 13.9203H1.00506L1.87108 13.4203ZM1.91047 12.1066L2.74499 12.6576H2.74499L1.91047 12.1066ZM4.12911 10.2227C4.12636 10.1488 4.12498 10.0746 4.12498 10H2.12498C2.12498 10.0994 2.12682 10.1984 2.13049 10.297L4.12911 10.2227ZM4.12498 10C4.12498 9.92539 4.12636 9.85115 4.12911 9.77731L2.13049 9.70304C2.12682 9.80162 2.12498 9.90062 2.12498 10H4.12498ZM3.96431 9.18919L2.74499 7.34244L1.07596 8.44442L2.29529 10.2912L3.96431 9.18919ZM2.74499 7.34244C2.69281 7.26341 2.68976 7.1617 2.73711 7.07969L1.00506 6.07969C0.578938 6.81775 0.606388 7.73321 1.07596 8.44442L2.74499 7.34244ZM2.73711 7.07969L3.83957 5.17018L2.10751 4.17018L1.00506 6.07969L2.73711 7.07969ZM3.83957 5.17018C3.88691 5.08817 3.97653 5.03995 4.07105 5.04563L4.19088 3.04922C3.34017 2.99816 2.53363 3.43212 2.10751 4.17018L3.83957 5.17018ZM4.07105 5.04563L6.2788 5.17814L6.39863 3.18173L4.19088 3.04922L4.07105 5.04563ZM6.872 5.02588C6.9977 4.94663 7.12658 4.87204 7.2584 4.80235L6.32355 3.03428C6.14671 3.12778 5.9739 3.2278 5.80543 3.334L6.872 5.02588ZM7.6854 4.36553L8.67407 2.3882L6.88521 1.49377L5.89655 3.4711L7.6854 4.36553ZM8.67407 2.3882C8.71641 2.3035 8.80298 2.25 8.89767 2.25V0.25C8.04544 0.25 7.26634 0.731505 6.88521 1.49377L8.67407 2.3882ZM8.89767 2.25H11.1026V0.25H8.89767V2.25ZM11.1026 2.25C11.1973 2.25 11.2838 2.3035 11.3262 2.3882L13.115 1.49377C12.7339 0.731505 11.9548 0.25 11.1026 0.25V2.25ZM11.3262 2.3882L12.315 4.36575L14.1038 3.47132L13.115 1.49377L11.3262 2.3882ZM12.7419 4.80253C12.8737 4.87221 13.0025 4.94677 13.1281 5.02599L14.1948 3.33415C14.0264 3.22799 13.8536 3.12801 13.6769 3.03453L12.7419 4.80253ZM13.7214 5.17827L15.9291 5.04576L15.8092 3.04935L13.6015 3.18187L13.7214 5.17827ZM15.9291 5.04576C16.0236 5.04009 16.1132 5.0883 16.1605 5.17031L17.8926 4.17031C17.4665 3.43225 16.6599 2.99829 15.8092 3.04935L15.9291 5.04576ZM16.1605 5.17031L17.263 7.07982L18.9951 6.07982L17.8926 4.17031L16.1605 5.17031ZM17.263 7.07982C17.3103 7.16183 17.3073 7.26355 17.2551 7.34257L18.9241 8.44455C19.3937 7.73335 19.4212 6.81788 18.9951 6.07982L17.263 7.07982ZM17.2551 7.34257L16.0357 9.18953L17.7047 10.2915L18.9241 8.44455L17.2551 7.34257ZM15.8709 9.7776C15.8736 9.85135 15.875 9.92549 15.875 10H17.875C17.875 9.90075 17.8731 9.80189 17.8695 9.70344L15.8709 9.7776ZM15.875 10C15.875 10.0745 15.8736 10.1486 15.8709 10.2224L17.8695 10.2966C17.8731 10.1981 17.875 10.0992 17.875 10H15.875ZM16.0357 10.8105L17.2551 12.6574L18.9241 11.5554L17.7047 9.70849L16.0357 10.8105ZM17.2551 12.6574C17.3073 12.7365 17.3103 12.8382 17.263 12.9202L18.9951 13.9202C19.4212 13.1821 19.3937 12.2667 18.9241 11.5555L17.2551 12.6574ZM17.263 12.9202L16.1605 14.8297L17.8926 15.8297L18.9951 13.9202L17.263 12.9202ZM16.1605 14.8297C16.1132 14.9117 16.0236 14.9599 15.9291 14.9542L15.8092 16.9506C16.6599 17.0017 17.4665 16.5677 17.8926 15.8297L16.1605 14.8297ZM15.9291 14.9542L13.7214 14.8217L13.6015 16.8181L15.8092 16.9506L15.9291 14.9542ZM13.1281 14.974C13.0025 15.0532 12.8737 15.1278 12.7419 15.1975L13.6769 16.9655C13.8536 16.872 14.0264 16.772 14.1948 16.6659L13.1281 14.974ZM12.315 15.6343L11.3262 17.6118L13.115 18.5062L14.1038 16.5287L12.315 15.6343ZM11.3262 17.6118C11.2838 17.6965 11.1973 17.75 11.1026 17.75V19.75C11.9548 19.75 12.7339 19.2685 13.115 18.5062L11.3262 17.6118ZM11.1026 17.75H8.89767V19.75H11.1026V17.75ZM8.89767 17.75C8.80298 17.75 8.71641 17.6965 8.67407 17.6118L6.88521 18.5062C7.26634 19.2685 8.04544 19.75 8.89767 19.75V17.75ZM8.67407 17.6118L7.6854 15.6345L5.89655 16.5289L6.88521 18.5062L8.67407 17.6118ZM7.2584 15.1977C7.12658 15.128 6.9977 15.0534 6.87199 14.9741L5.80544 16.666C5.9739 16.7722 6.14671 16.8722 6.32355 16.9657L7.2584 15.1977ZM6.2788 14.8219L4.07105 14.9544L4.19088 16.9508L6.39863 16.8183L6.2788 14.8219ZM4.07105 14.9544C3.97653 14.96 3.88691 14.9118 3.83957 14.8298L2.10751 15.8298C2.53363 16.5679 3.34017 17.0018 4.19088 16.9508L4.07105 14.9544ZM3.83957 14.8298L2.73711 12.9203L1.00506 13.9203L2.10751 15.8298L3.83957 14.8298ZM2.73711 12.9203C2.68976 12.8383 2.69281 12.7366 2.74499 12.6576L1.07596 11.5556C0.606388 12.2668 0.578939 13.1823 1.00506 13.9203L2.73711 12.9203ZM2.74499 12.6576L3.96431 10.8108L2.29529 9.70883L1.07596 11.5556L2.74499 12.6576Z"
              fill="#262626"
            />
          </svg>
        );
      }
      case Icons.ARCHIVE: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.54415 4.69957L2.55132 10.6781C2.51733 10.78 2.5 10.8868 2.5 10.9943V14.6654C2.5 15.7699 3.39543 16.6654 4.5 16.6654H15.5C16.6046 16.6654 17.5 15.7699 17.5 14.6654V10.9943C17.5 10.8868 17.4827 10.78 17.4487 10.6781L15.4558 4.69958C15.1836 3.88289 14.4193 3.33203 13.5585 3.33203H6.44152C5.58066 3.33203 4.81638 3.88289 4.54415 4.69957Z"
              stroke={color || '#515151'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M4.16797 8.33203H7.08464V8.7487C7.08464 10.3595 8.39047 11.6654 10.0013 11.6654V11.6654C11.6121 11.6654 12.918 10.3595 12.918 8.7487V8.33203H15.8346"
              stroke={color || '#515151'}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.MULTI_SELECT: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7 10L9.5 12.5L17.5 4.5"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V15C2.5 16.3807 3.61929 17.5 5 17.5H15C16.3807 17.5 17.5 16.3807 17.5 15V10"
              stroke="#262626"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }
      case Icons.MEGA_PHONE: {
        return (
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.1363 2.50059C12.3556 4.33901 8.74472 6.80982 2.94961 8.28897C2.14692 8.49385 1.62821 9.28708 1.80045 10.0974L2.00836 11.0755C2.1806 11.8859 2.9771 12.3995 3.79373 12.2602C9.68945 11.2544 13.9931 12.0429 15.454 13.4049C15.858 13.7815 16.4097 14.1485 16.9499 14.0337C17.4901 13.9188 17.835 13.3878 17.7201 12.8476L15.4331 2.08799C15.3183 1.54777 14.7873 1.20293 14.247 1.31775C13.7068 1.43258 13.3521 1.99224 13.1363 2.50059Z"
              stroke="#262626"
              strokeWidth="2"
              strokeLinejoin="round"
            />
            <path
              d="M5.35864 12.4082L8.30714 17.705C8.52066 18.0886 8.95939 18.2881 9.3888 18.1968L10.2764 18.0081C10.9345 17.8682 11.2695 17.1314 10.9423 16.5436L8.29309 11.7845"
              stroke="#262626"
              strokeWidth="2"
            />
          </svg>
        );
      }
      case Icons.CALENDAR: {
        return (
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle opacity="0.08" cx="16" cy="16" r="16" fill="#04A451" />
            <path
              d="M21.25 10H10.75C9.7835 10 9 10.7835 9 11.75V22.25C9 23.2165 9.7835 24 10.75 24H21.25C22.2165 24 23 23.2165 23 22.25V11.75C23 10.7835 22.2165 10 21.25 10Z"
              stroke="#04A451"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M19.5 8.5V11.5"
              stroke="#04A451"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M12.5 8.5V11.5"
              stroke="#04A451"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M9 15H23"
              stroke="#04A451"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }

      default: {
        return null;
      }
    }
  };

  return (
    <div testid={testid} onClick={onClick} className={classNames(styles.icons, className)}>
      {getIcons()}
    </div>
  );
};

Icons.SETTINGS = 'settings';
Icons.ARCHIVE = 'archive';
Icons.MEGA_PHONE = 'megaPhone';
Icons.MULTI_SELECT = 'multiSelect';
Icons.CALENDAR = 'calendarGreen';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  testid: PropTypes.string,
  onClick: PropTypes.func,
  color: PropTypes.string,
};

Icons.defaultProps = {
  className: '',
  variant: '',
  testid: undefined,
  onClick: () => {},
  color: '#262626',
};
